import { IconDeviceTv } from "@tabler/icons-react";
import React, { useState, useEffect } from "react";
import Accordion from 'react-bootstrap/Accordion';
import DemoVideoPlay from "./DemoVideoPlay";
import Icon from "@mdi/react";
import { mdiMonitor } from "@mdi/js";


export default function Demos() {
    const demoArray = [
        {
            title: "Invitd Overview & Training",
            url: "https://www.youtube.com/embed/gcFvxrs_-5o",
            body: "Understand Basic of how Invitd works. Create Invitation and Deliver invitation to the clients.",
            thumnail: "https://img.youtube.com/vi/gcFvxrs_-5o/0.jpg",
            isNew: true
        },
        {
            title: "How to copy youtube video link?",
            url: "https://www.youtube.com/embed/CI6iF0U09xY",
            body: "",
            thumnail: "https://img.youtube.com/vi/CI6iF0U09xY/0.jpg",
            isNew: false
        }
    ];

    const [demos, setDemos] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [url, setUrl] = useState(false);
    const [title, setTitle] = useState(false);

    useEffect(() => {
        setDemos(demoArray);
    }, []);

    const playVideo = (e, url, title) => {
        setUrl(url);
        setTitle(title);
        setShowModal(true);
    }

    const closeModal = () => {
        setShowModal(false);
        setUrl("");
        setTitle("");
    }

    return (
        <>
            <div className="d-flex flex-column">
                <div className="row">
                    <div className="col">
                        <div className="card">
                            <div className="card-body">
                                <div className="page-header d-flex">
                                    <h5 style={{ fontSize: "1.09375rem" }}>
                                        <Icon path={mdiMonitor} size={"2rem"} className="me-3" />Watch Demo</h5>
                                </div>
                                <div className="accordion" id="accordionExample">
                                    <Accordion className="demo">
                                        {
                                            demos.map((demo, index) => {
                                                return (<Accordion.Item eventKey={index} key={index}>
                                                    <Accordion.Header>{demo.title}
                                                        {demo.isNew && (<small className="ms-2 badge-soft-success rounded-pill">New</small>)}
                                                    </Accordion.Header>
                                                    <Accordion.Body>
                                                        <div className="row">
                                                            <div className="col-sm-10 col-md-7" style={{ whiteSpace: "break-spaces" }}><div>
                                                                {demo.body}
                                                            </div>
                                                            </div>
                                                            <div className="col-sm-10 col-md-4">
                                                                <div className="position-relative youtube">
                                                                    <img className="img-fluid thumbnail" src={demo.thumnail} height="200px" width="400px" />
                                                                    <div className="position-absolute top-50 start-50 translate-middle" onClick={(e) => playVideo(e, demo.url, demo.title)}>
                                                                        <img src="https://img.icons8.com/doodle/48/null/youtube-play--v2.png" alt="play" className="play-icon" style={{ cursor: "pointer" }} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Body>
                                                </Accordion.Item>)
                                            })
                                        }

                                    </Accordion>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showModal && (
                <DemoVideoPlay url={url}
                    onClose={closeModal}
                    alt={title} />)}
        </>
    );
}